import React from "react";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../redux/store";
import * as Styles from "../../../../../../common-deprecated/styles/v2/toyota/components/FinanceToggle";
import { BnbLabel } from "../../../utils/labels";
import { setFinanceOption } from "../../../../../../common-deprecated/redux/actions/UtilActions";
import type { FinanceOptionType } from "../../../../../../common-deprecated/types/CommonTypes";
import { showBnbMonthlyRates } from "../../../utils/settings/bnbFinanceSettingUtils";
import { trackFinanceToggle } from "../../../utils/tracking";
import { isMergedEngineStep } from "../../../utils/modelEngineUtils";
import { NavStep } from "../../../../shared-logic/utils/Navigation";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

type FinanceTogglePropsType = {
    modelCode: string;
    isFullWidth?: boolean;
};

const FinanceToggle = (props: FinanceTogglePropsType): JSX.Element | null => {
    const { modelCode, isFullWidth } = props;

    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const step = useBnbSelector((state) => state.navigation.step);
    const showMonthlyRates = useBnbSelector((state) =>
        showBnbMonthlyRates(state.commonSettings, state.bnbSettings, modelCode, state.navigation.step),
    );
    const isMergedModelStep = useBnbSelector((state) => isMergedEngineStep(state.bnbSettings, step));
    const trackingStep = isMergedModelStep ? NavStep.ModelEngine : step;

    if (!showMonthlyRates) return null;

    const onClickFn =
        (option: FinanceOptionType): (() => void) =>
        () => {
            if (option !== financeOption) {
                trackFinanceToggle(trackingStep, option, "cc-action");
                dispatch(setFinanceOption(option));
            }
        };

    return (
        <Styles.Wrapper fullWidth={isFullWidth} isMonthlyActive={financeOption === "monthly"}>
            <Styles.ToggleItem type="button" onClick={onClickFn("cash")}>
                <Styles.LineClamp>
                    <BnbLabel label="financeOptionCash" />
                </Styles.LineClamp>
            </Styles.ToggleItem>
            <Styles.ToggleItem type="button" onClick={onClickFn("monthly")}>
                <Styles.LineClamp>
                    <BnbLabel label="financeOptionMonthly" />
                </Styles.LineClamp>
            </Styles.ToggleItem>
        </Styles.Wrapper>
    );
};

export default FinanceToggle;
